import './bootstrap';

//app
require('./promotions/alpine');
